import "./bootstrap";

import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import mainStore from './store'
import App from './App.vue'
import Vuex from "vuex";
import VueInputMask from "vue-inputmask";

import vSelect from 'vue-select'

import VueToastr from "@deveodk/vue-toastr";
import ToggleButton from 'vue-js-toggle-button'
import VueSimpleSuggest from "vue-simple-suggest";

// Import configured axios instance
import '@/libs/axios'

window.axios = axios

import { VueTables, ServerTable, ClientTable, Event } from "vue-tables-2";

import "../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
import "./assets/css/main.css";
import "./assets/auxiliary/fontawesome/css/all.min.css";
import 'vue-select/dist/vue-select.css';
import '../node_modules/moment/moment'
import "vue-simple-suggest/dist/styles.css";

import VueLoading from 'vuejs-loading-plugin'

// using default options

// overwrite defaults
Vue.use(VueLoading, {
  dark: false, // default false
  text: '', // default 'Loading'
  loading: false, // default false
  background: 'rgb(255,255,255, 0.15)', // set custom background
  classes: ['loadingOverwrite'] // array, object or string
})

window.moment = require('moment');
moment.locale('pt-br');

import swal from "sweetalert";

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

const translation = {
  count: "Mostrando {from} de {to} até {count} de registros",
  filter: "Pesquisar:",
  filterPlaceholder: "Pesquisar",
  limit: "Registros:",
  noResults: "Nenhum registro encontrado",
  page: "Página:",
  filterBy: "Filtrar por {column}",
  // for dropdown pagination filterBy: 'Filter by {column}',
  // Placeholder for search fields when filtering by column loading:'Loading...',
  // First request to server defaultOption:'Select {column}'
  // default option for list filters }
};

const options = {
  requestFunction: function (data) {
    // data.token = this.$store.getters.token
    return axios
      .get(this.url, {
        params: data,
      })
      .catch(
        function (e) {
          this.dispatch("error", e);
          router.push("/login");
        }.bind(this)
      );
  },
  texts: translation,
  pagination: { chunk: 15, dropdown: false, nav: "scroll" },
  perPage: 10,
  perPageValues: [10, 25, 50, 100],
};

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(ServerTable, options, false, "bootstrap4", "footerPagination");

Vue.use(VueToastr);
Vue.use(ToggleButton)
Vue.use(VueSimpleSuggest)
Vue.use(VueInputMask.default);

// Composition API
Vue.use(VueCompositionAPI)
Vue.component('v-select', vSelect)

Vue.use(Vuex);

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBni4q53Pz1X6zwWqQznhNRg2-79ajar6E',
    libraries: '', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

// import core styles
require('@core/scss/core.scss')
require('@core/scss/base/pages/app-chat-list.scss')
require('@core/scss/base/pages/app-chat.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// export const store = new Vuex.Store(mainStore);

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.dispatch("initialize");
  },
}).$mount('#app')

Vue.prototype.$message = function (title, msg, type) {
  let newMsg = "";
  if (msg instanceof Object) {
    newMsg += "<ul>";
    for (var key in msg) {
      if (msg.hasOwnProperty(key)) {
        newMsg += "<li>";
        newMsg += msg[key];
        newMsg += "</li>";
      }
    }
    newMsg += "</ul>";
  } else newMsg = msg;

  this.$toastr("add", {
    title: title,
    msg: newMsg,
    clickClose: true,
    timeout: 4000,
    position: "toast-top-right",
    type: type,
  });
};

Vue.prototype.$error = function (error) {
  let errors = error.response ? error.response.data : error;

  if (typeof errors === "object") {
    let html = "<ul>";

    $.each(errors, function (key, value) {
      html += "<li>" + value[0] + "</li>";
    });

    html += "</ul>";

    errors = html;
  }

  this.$message(null, errors, "error");
};